<template>
  <div class="works-management">
    <page-title title="筛选">
      <el-row class="works-management__filter-header" :gutter="20">
        <el-col :xl="4" :span="6">
          <span>作品ID：</span>
          <el-input
            size="small"
            v-model="filter.workId"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>作品名称：</span>
          <el-input
            size="small"
            v-model="filter.workName"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>创作者：</span>
          <el-input
            size="small"
            v-model="filter.creator"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :xl="3" :span="6">
          <span>作品类型：</span>
          <el-select
            size="small"
            v-model="filter.workType"
            placeholder="请选择"
          >
            <el-option label="图片" value="1"></el-option>
            <el-option label="音频" value="2"></el-option>
            <el-option label="视频" value="3"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button size="small" @click="search">查询</el-button>
          <el-button size="small" @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </page-title>

    <div class="works-management__tabs" style="padding: 10px 20px">
      <el-radio-group v-model="activeTab" size="small" @change="handleTabClick">
        <el-radio-button label=""
          >全部<span v-if="statusCount.all"
            >（{{ statusCount.all }}）</span
          ></el-radio-button
        >
        <el-radio-button :label="5"
          >销售中<span v-if="statusCount.passCount"
            >（{{ statusCount.passCount }}）</span
          ></el-radio-button
        >
        <el-radio-button :label="4"
          >待发布<span v-if="statusCount.issueCount"
            >（{{ statusCount.issueCount }}）</span
          ></el-radio-button
        >
        <el-radio-button :label="1"
          >审核中<span v-if="statusCount.reviewCount"
            >（{{ statusCount.reviewCount }}）</span
          ></el-radio-button
        >
        <el-radio-button :label="3"
          >未通过<span v-if="statusCount.notPassCount"
            >（{{ statusCount.notPassCount }}）</span
          ></el-radio-button
        >
      </el-radio-group>
    </div>

    <page-title title="数据列表">
      <div class="works-management__body">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
        >
          <el-table-column label="作品信息" width="300">
            <template slot-scope="scope">
              <div class="prod">
                <div class="resour">
                  <img
                    v-if="scope.row.worksType == 1"
                    :src="scope.row.worksUrl"
                    style="width: 100%; height: 40px; object-fit: contain"
                  />
                  <!-- <el-image v-if="scope.row.worksType == 1"  :preview-src-list="[scope.row.worksUrl]" :src="scope.row.worksUrl" fit="contain" style="width: 100%;height: 40px;" ></el-image> -->
                  <img
                    v-if="scope.row.worksType == 2"
                    style="width: 100%; height: 40px; object-fit: contain"
                    src="@/assets/images/upload/audioIcon.png"
                    alt=""
                  />
                  <video
                    v-if="scope.row.worksType == 3"
                    :src="scope.row.worksUrl"
                    width="100%"
                    height="40px"
                  ></video>
                </div>
                <div>
                  <p>{{ scope.row.title }}</p>
                  <p style="color: #999">{{ scope.row.id }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="workType" label="作品类型">
            <template slot-scope="scope">
              {{ getWorkTypeText(scope.row.worksType) }}
            </template>
          </el-table-column>
          <el-table-column prop="identityAuthType" label="创作者类型">
            <template slot-scope="scope">
              {{ scope.row.identityAuthType == "1" ? "个人" : "企业" }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="创作者名称"></el-table-column>
          <el-table-column prop="portraitRight" label="授权类型">
            <template slot-scope="scope">
              {{
                ["有授权", "无授权", "不涉及授权"][scope.row.portraitRight - 1]
              }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.status)">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="finishTime" label="创建时间"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status == '1'"
                type="text"
                @click="handleReview(scope.row)"
                >审核</el-button
              >
              <el-button type="text" @click="handleDetail(scope.row)"
                >详情</el-button
              >
              <el-button
                v-if="scope.row.status == '5'"
                type="text"
                @click="handleOffline(scope.row)"
                >下架</el-button
              >
              <el-button
                v-if="scope.row.status == '4'"
                type="text"
                @click="handleOnline(scope.row)"
                >上架</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          @current-change="getList"
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="search"
        ></cus-pagination>
      </div>
    </page-title>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import { listAll, updateStatus, getWorksCount } from "@/api/works";

export default {
  components: {
    PageTitle,
    CusPagination,
  },
  data() {
    return {
      loading: true,
      filter: {
        workId: "",
        workName: "",
        creator: "",
        workType: "",
        status: "",
      },
      activeTab: "",
      statusCount: {
        all: 0,
        issueCount: 0,
        notPassCount: 0,
        passCount: 0,
        passCount: 0,
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  computed: {
    totolNumber() {
      return this.total ? this.total : "";
    },
  },
  methods: {
    getWorkTypeText(type) {
      const map = {
        1: "图片",
        2: "音频",
        3: "视频",
      };
      return map[type] || "未知";
    },
    getStatusText(status) {
      const map = {
        5: "销售中",
        4: "待发布",
        1: "审核中",
        3: "未通过",
      };
      return map[status] || "未知";
    },
    getStatusTagType(status) {
      const map = {
        5: "success",
        3: "danger",
        4: "warning",
      };
      return map[status] || "";
    },
    async getList() {
      this.loading = true;
      const params = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        name: this.filter.creator,
        title: this.filter.workName,
        worksType: this.filter.workType,
        status: this.activeTab,
        id: this.filter.workId,
        identityType: 2,
      };

      try {
        const { data } = await this.$ajax.get(listAll, params);
        if (data.code === 200) {
          this.tableData = data.data.records || [];
          this.total = data.data.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      this.filter = {
        workId: "",
        workName: "",
        creator: "",
        workType: "",
        status: "",
      };
      this.getList();
    },
    handleTabClick(tab) {
      this.filter.status = "";
      this.getList();
    },
    handleReview(row) {
      console.log("审核作品", row);
      this.$router.push({ path: `/listWorks/${row.id}/2` });
    },
    handleDetail(row) {
      console.log("查看详情", row);
      this.$router.push({ path: `/listWorks/${row.id}/1` });
    },
    handleOffline(row) {
      this.handleChangeStatus(row.id, 4);
    },
    handleOnline(row) {
      this.handleChangeStatus(row.id, 5);
    },
    handleChangeStatus(id, status) {
      this.$ajax
        .post(updateStatus, {
          id: id,
          status: status,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(status == 4 ? "下架成功" : "上架成功");
            this.search();
          }
        });
    },
    getWorksCountFn() {
      this.$ajax
        .get(getWorksCount, { type: 2, identityType: 2 })
        .then((res) => {
          if (res.data.code == 200) {
            const { issueCount, notPassCount, passCount, reviewCount } =
              res.data.data;
            this.statusCount = {
              all: issueCount + notPassCount + passCount + reviewCount,
              issueCount,
              notPassCount,
              passCount,
              reviewCount,
            };
          }
        });
    },
  },

  created() {
    this.getWorksCountFn();
    if (this.$route.query.status) {
      this.activeTab = this.$route.query.status;
    }
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.works-management {
  .prod {
    display: flex;
    align-items: center;
    .resour {
      width: 100px;
    }
  }
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__tabs {
    margin: 20px 0;
    background: #fff;
    padding: 0 20px;
  }

  &__body {
    .el-button {
      color: #002b9c;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}

/deep/.el-radio-group {
  .is-active {
    .el-radio-button__inner {
      background-color: #002b9c;
      border-color: #002b9c;
    }
  }
}
</style>
